/**
 * Dagens dato i Europe/Oslo, `YYYY-MM-DD` — samme dag som API-et filtrerer på
 * (#159). `sv-SE` gir ISO-rekkefølgen. Delt av Familie-konsollen og Oppsett
 * (#166: bursdagens `max` var UTC-dato og lå en dag bak etter midnatt).
 */
export function osloToday(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Oslo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}
